import React, { Component } from 'react';

import * as S from './TabLabel.styles';

export class TabLabel extends Component {
  render() {
    const { label, active, onClick } = this.props;
    return (
      <S.LabelBody active={active} onClick={onClick}>
        {label}
      </S.LabelBody>
    );
  }
}

export default TabLabel;
